// import external dependencies
//import 'jquery'

// Import Select 2
import 'select2'

// Import Slick
import 'slick-carousel/slick/slick.min';

import { Megamenu } from './components/megamenu'
import { Search } from './components/search'
import { Layout_Switcher } from './components/layout-switcher'
import { Loadmore } from './components/loadmore'
import { Backtotop } from './components/back-to-top'
import { Browseissue } from './components/browse-issue'
import { Sliderhomepage } from './components/slider-homepage'
import { Sliderlogo } from './components/slider-logo'
import { Accordio } from './components/accordion'
import { FilterMobile } from './components/filter-mobile'
import { Masonrylayout } from './components/masonry-layout'


$( document ).ready( () => {

    const menu = new Megamenu
    const masonry = new Masonrylayout( {
        list_wrapper: '.buyers-list',
    } )
    const search = new Search( {
        onButtonClick: () => {
            menu.hide()
        },
    } )
    const advertiserFilter = new Layout_Switcher( {
        list_container: $( '.advertiser-list' ),
    } )
    const buyerFilter = new Layout_Switcher( {
        list_container: $( '.buyers-list' ),
        action_click: ( action ) => {
            masonry.layout( action )
        },
    } )
    const loadmore = new Loadmore
    const backtotop = new Backtotop
    const browseissue = new Browseissue
    const sliderhomepage = new Sliderhomepage
    const sliderlogo = new Sliderlogo
    const accordio = new Accordio( {
        action_item: $( '.buyers-list header h3' ),
        action_click: () => {
            masonry.layout( 'update' )
        },
    } )
    const filtermobile = new FilterMobile

    menu.init()
    search.mobile_init()
    advertiserFilter.initfilter()
    buyerFilter.initfilter()
    loadmore.init()
    backtotop.init()
    browseissue.init()
    sliderhomepage.init()
    sliderlogo.init()
    accordio.init()
    filtermobile.init()
    masonry.init()
} )



// WEBPACK FOOTER //
// ./scripts/main.js